{
  "name": "spa-mono",
  "version": "2026.11.04.01",
  "private": true,
  "workspaces": [
    "apps/*",
    "packages/*"
  ],
  "scripts": {
    "nx": "nx --outputStyle=stream-without-prefixes",
    "dev": "nx run tools:dev",
    "build": "bunx nx run-many -t build --all",
    "tsc": "nx run-many -t typecheck --all --parallel 10 --outputStyle=stream-without-prefixes",
    "tscw": "bunx nx run-many -t typecheck-watch --all",
    "lint:oxlint": "oxlint --config .oxlintrc.json apps packages",
    "lint:oxlint:errors": "oxlint --config .oxlintrc.json --quiet apps packages",
    "lint:eslint": "bunx nx run-many -t lint --fix --all --parallel 10 --outputStyle=stream-without-prefixes",
    "lint": "bun run lint:oxlint && bun run lint:eslint",
    "format": "oxfmt",
    "check:playwright-image": "bun scripts/check-playwright-image.ts",
    "test": "bunx nx run-many -t test --all ",
    "test:coverage": "bunx nx run-many -t test --all --coverage",
    "test:visual": "bun run manager:test:visual; bun run ui:test:visual",
    "test:visual:update": "bun run manager:test:visual:update; bun run ui:test:visual:update",
    "schema": "bunx nx run-many -t schema --all",
    "translations:api": "bunx nx run tools:translations:api",
    "translations:download": "bunx nx run-many -t translations:download --all",
    "postinstall": "node scripts/check-nested-node-modules.mjs",
    "prepare": "husky",
    "manager:dev": "nx run manager:dev",
    "manager:lint": "nx run manager:lint",
    "manager:tsc": "nx run manager:typecheck",
    "manager:permissions": "bunx nx run manager:permissions",
    "manager:translations": "bunx nx run manager:translations:download",
    "manager:schema": "bunx nx run manager:schema",
    "manager:schema:manager": "bunx nx run manager:schema:manager",
    "manager:preview": "nx run manager:preview",
    "manager:knip": "knip --config knip.manager.json",
    "booking-portal:dev": "nx run booking-portal:dev",
    "booking-portal:translations": "bunx nx run booking-portal:translations:download",
    "documents:translations": "bunx nx run shared-documents:i18n:download",
    "booking-portal:schema": "bunx nx run booking-portal:schema",
    "booking-portal:preview": "nx run booking-portal:preview",
    "preview": "bunx nx run-many -t preview --all",
    "booking-portal:knip": "knip --config knip.booking-portal.json",
    "pdf-renderer:dev": "nx run pdf-renderer:serve",
    "pdf-renderer:test": "nx run pdf-renderer:test",
    "pdf-renderer:test:pipeline": "nx run pdf-renderer:test:pipeline",
    "pdf-renderer:validate": "nx run pdf-renderer:validate",
    "pdf-renderer:validate:pdf": "nx run pdf-renderer:validate:pdf",
    "pdf-renderer:validate:xml": "nx run pdf-renderer:validate:xml",
    "pdf-renderer:golden:update": "nx run pdf-renderer:golden:update",
    "pdf-renderer:fixtures": "nx run pdf-renderer:fixtures",
    "pdf-renderer:openapi": "nx run pdf-renderer:openapi",
    "pdf-renderer:benchmark": "nx run pdf-renderer:benchmark",
    "payment-page:dev": "nx run payment-page:dev",
    "payment-page:translations": "bunx nx run payment-page:translations:download",
    "payment-page:knip": "knip --config knip.payment-page.json",
    "release": "nx run tools:release",
    "sort-changelog-progress": "nx run tools:sort-changelog-progress",
    "validate-changelog-progress": "nx run tools:validate-changelog-progress",
    "audit": "bun audit --audit-level=critical",
    "ci:affected:typecheck": "nx affected -t typecheck --base=${NX_BASE} --head=${NX_HEAD} --outputStyle=stream-without-prefixes --parallel 1",
    "ci:affected:test": "nx affected -t test --base=${NX_BASE} --head=${NX_HEAD} --outputStyle=stream-without-prefixes --parallel 1",
    "ci:affected:build": "nx affected -t build --base=${NX_BASE} --head=${NX_HEAD} --outputStyle=stream-without-prefixes --parallel 1",
    "ci:affected:validate": "bun run ci:affected:typecheck && bun run ci:affected:test && bun run ci:affected:build",
    "prepush:affected:validate": "bun run ci:affected:typecheck && bun run ci:affected:test && bun run ci:affected:build",
    "registry:build:manager": "nx run ui:registry:build:manager",
    "registry:build:standalone": "nx run ui:registry:build:standalone",
    "registry:storybook:build": "nx run ui:storybook:build",
    "registry:build:all": "nx run ui:registry:build:all",
    "registry:build": "nx run ui:registry:build:manager",
    "registry:storybook": "nx run ui:storybook",
    "manager:test:e2e": "nx run manager:test:e2e",
    "manager:test:e2e:report": "playwright show-report apps/manager/playwright-report-e2e",
    "manager:test:visual:build": "sh ci/build-visual-tests.sh",
    "manager:test:visual": "sh ci/run-manager-visual-tests.sh",
    "manager:test:visual:report": "playwright show-report apps/manager/tests/visual/playwright-report",
    "manager:test:visual:update": "sh ci/run-manager-visual-tests.sh update",
    "manager:test:visual:update:ci": "sh ci/update-manager-visual-snapshots.sh",
    "manager:storybook": "nx run manager:storybook",
    "ui:test:visual:build": "sh ci/build-visual-tests.sh",
    "ui:test:visual": "sh ci/run-visual-tests.sh",
    "ui:test:visual:report": "playwright show-report packages/ui/tests/visual/playwright-report",
    "ui:test:visual:update": "sh ci/run-visual-tests.sh update",
    "ui:test:visual:update:ci": "sh ci/update-ui-visual-snapshots.sh"
  },
  "dependencies": {
    "@codemirror/commands": "^6.10.3",
    "@codemirror/lang-javascript": "^6.2.5",
    "@codemirror/language": "^6.12.3",
    "@codemirror/lint": "^6.9.5",
    "@codemirror/state": "6.7.1",
    "@codemirror/view": "^6.41.0",
    "@floating-ui/dom": "^1.6.0",
    "@floating-ui/vue": "^1.1.11",
    "@headlessui/vue": "^1.7.23",
    "@hono/node-server": "^1.19.5",
    "@iconify-json/material-symbols": "^1.2.65",
    "@kyvg/vue3-notification": "^3.4.2",
    "@mdi/font": "^7.4.47",
    "@number-flow/vue": "^0.4.12",
    "@popperjs/core": "^2.11.8",
    "@sentry/vite-plugin": "^5.1.1",
    "@sentry/vue": "^8.55.1",
    "@stripe/stripe-js": "^5.10.0",
    "@tanstack/query-core": "^5.96.2",
    "@tanstack/vue-query": "^5.96.2",
    "@tanstack/vue-query-devtools": "^5.91.0",
    "@tanstack/vue-table": "^8.21.3",
    "@tiptap/core": "3.30.5",
    "@tiptap/extension-bold": "3.27.3",
    "@tiptap/extension-document": "3.27.3",
    "@tiptap/extension-hard-break": "3.27.3",
    "@tiptap/extension-italic": "3.27.3",
    "@tiptap/extension-link": "3.27.3",
    "@tiptap/extension-paragraph": "3.27.3",
    "@tiptap/extension-text": "3.27.3",
    "@tiptap/pm": "3.27.3",
    "@tiptap/suggestion": "3.27.3",
    "@tiptap/vue-3": "3.27.3",
    "@unhead/vue": "^3.1.1",
    "@vee-validate/rules": "^4.15.1",
    "@vue/server-renderer": "3.5.42",
    "@vuepic/vue-datepicker": "^11.0.3",
    "@vueuse/core": "^13.9.0",
    "@vueuse/motion": "^2.2.6",
    "@vueuse/rxjs": "^13.9.0",
    "@vueuse/shared": "^13.9.0",
    "axios": "^1.20.0",
    "chart.js": "^4.5.1",
    "clsx": "^2.1.1",
    "codemirror": "^6.0.2",
    "dayjs": "^1.11.20",
    "gsap": "^3.14.2",
    "hono": "^4.13.13",
    "js-confetti": "^0.12.0",
    "libphonenumber-js": "^1.12.41",
    "lodash-es": "^4.18.1",
    "lottie-web": "^5.13.0",
    "lucide-vue-next": "^0.477.0",
    "marked": "^15.0.12",
    "memoize": "^10.2.0",
    "motion-v": "^0.9.0",
    "msw": "^2.13.0",
    "paper": "^0.12.18",
    "pinia": "^3.0.4",
    "pinia-plugin-persistedstate": "^4.7.1",
    "pino": "^10.3.1",
    "posthog-js": "^1.386.0",
    "reka-ui": "2.9.0",
    "rxjs": "^7.8.2",
    "safe-stable-stringify": "^2.5.0",
    "tailwind-merge": "^3.5.0",
    "tailwindcss": "^3.4.19",
    "tailwindcss-animate": "^1.0.7",
    "validator": "^13.15.35",
    "vee-validate": "^4.15.1",
    "vue": "3.5.42",
    "vue-chartjs": "^5.3.3",
    "vue-draggable-plus": "^0.6.1",
    "vue-i18n": "~10.0.8",
    "vue-router": "^4.6.4",
    "vue-virtual-scroller": "^2.0.1",
    "vue3-touch-events": "^4.2.0",
    "vuetify": "~4.2.2",
    "zod": "^4.6.7"
  },
  "devDependencies": {
    "@intlify/core-base": "10.0.8",
    "@nx/eslint": "23.3.1",
    "@nx/eslint-plugin": "23.3.1",
    "@nx/storybook": "23.3.1",
    "@nx/vite": "23.3.1",
    "@nx/vitest": "23.3.1",
    "@playwright/test": "1.64.1",
    "@storybook/addon-a11y": "^10.6.2",
    "@storybook/addon-docs": "^10.6.2",
    "@storybook/addon-vitest": "^10.6.2",
    "@storybook/vue3": "^10.6.2",
    "@storybook/vue3-vite": "^10.6.2",
    "@tailwindcss/container-queries": "^0.1.1",
    "@tailwindcss/nesting": "^0.0.0-insiders.565cd3e",
    "@types/intercom-web": "^2.8.26",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^24",
    "@types/sort-json": "^2.0.3",
    "@types/sortablejs": "^1.15.9",
    "@types/validator": "^13.15.10",
    "@typescript-eslint/eslint-plugin": "^8.58.0",
    "@typescript-eslint/parser": "^8.58.0",
    "@vitejs/plugin-vue": "6.0.5",
    "@vitest/browser": "5.0.5",
    "@vitest/browser-playwright": "5.0.5",
    "@vitest/coverage-v8": "5.0.5",
    "@vue/eslint-config-typescript": "^14.7.0",
    "@vue/test-utils": "^2.4.6",
    "@xhmikosr/decompress": "^11.1.4",
    "autoprefixer": "^10.4.27",
    "dotenv": "^17.4.1",
    "dtsgenerator": "^3.19.2",
    "eslint": "^10.2.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-import-x": "^4.16.2",
    "eslint-plugin-oxlint": "^1.58.0",
    "eslint-plugin-storybook": "^10.6.2",
    "eslint-plugin-tailwindcss": "3.18.2",
    "eslint-plugin-unused-imports": "^4.4.1",
    "eslint-plugin-vue": "^10.8.0",
    "happy-dom": "^21.0.4",
    "husky": "^9.1.7",
    "jiti": "2.4.2",
    "knip": "^5.88.1",
    "node-zugferd": "^0.1.1-beta.1",
    "nx": "23.3.1",
    "openapi-typescript": "^7.13.0",
    "oxfmt": "^0.71.0",
    "oxlint": "^1.59.0",
    "pdf-lib": "^1.17.1",
    "playwright": "1.64.1",
    "postcss": "^8.5.8",
    "postcss-import": "^16.1.1",
    "replace-in-files": "^3.0.0",
    "sass-embedded": "^1.99.0",
    "shadcn-vue": "^2.3.2",
    "sort-json": "^2.0.1",
    "start-server-and-test": "^2.0.3",
    "storybook": "^10.6.2",
    "tslib": "^2.8.1",
    "tsx": "^4.21.0",
    "typescript": "^6.0.2",
    "unpdf": "^1.8.1",
    "unplugin-fonts": "^1.4.0",
    "unplugin-icons": "^22.5.0",
    "unplugin-vue-components": "^29.2.0",
    "vite": "^8.3.5",
    "vite-plugin-dts": "~4.5.4",
    "vite-plugin-vue-devtools": "^8.1.1",
    "vite-plugin-vuetify": "^2.1.3",
    "vitest": "5.0.5",
    "vue-tsc": "^3.3.11"
  },
  "overrides": {
    "@codemirror/state": "6.7.1",
    "@lezer/common": "1.5.2",
    "fast-xml-parser": "5.11.2",
    "undici": "^7.30.1"
  },
  "engines": {
    "node": "24.22.1",
    "npm": ">=10.1.0"
  },
  "msw": {
    "workerDirectory": [
      "packages/msw/public"
    ]
  }
}
